import {lazy} from '@aboutyou/lazy-imports';
import React, {FC} from 'react';
import {recentlySearchedLabelsInterface} from './SearchSuggestionsHistory';
import {SearchSuggestionsProps} from './SearchSuggestionsView';

const SearchSuggestions = lazy(() =>
  import('./SearchSuggestions.eager').then(mod => ({
    default: mod.SearchSuggestions,
  })),
);
const SearchSuggestionsHistory = lazy(() =>
  import('./SearchSuggestionsHistory').then(mod => ({
    default: mod.SearchSuggestionsHistory,
  })),
);

export const MIN_CHARS_TO_SEARCH = 2;

interface ConditionalSearchSuggestionsHistoryProps {
  search: string;
  handleRemoveInputFocus: VoidFunction;
  isInputFocused: boolean;
}

export const ConditionalSearchSuggestionsHistory: FC<
  ConditionalSearchSuggestionsHistoryProps &
    Omit<SearchSuggestionsProps, 'className' | 'onClick'> &
    recentlySearchedLabelsInterface
> = ({
  isInputFocused,
  search,
  handleRemoveInputFocus,
  searchBarRef,
  isSearchBarExpanded,
  createSearchPath,
  onClickSuggestion,
  shouldDisableSearchBarResults,
  disableKeyNavigation,
  enableRightArrow,
  recentlySearchedLabels,
  onNavigateSuggestionList,
}) => {
  if (!isInputFocused) {
    return null;
  }

  return (
    <>
      {search.length < MIN_CHARS_TO_SEARCH ? (
        <SearchSuggestionsHistory
          searchBarRef={searchBarRef}
          isSearchBarExpanded={isSearchBarExpanded}
          onClick={handleRemoveInputFocus}
          onClickSuggestion={onClickSuggestion}
          createSearchPath={createSearchPath}
          shouldDisableSearchBarResults={shouldDisableSearchBarResults}
          disableKeyNavigation={disableKeyNavigation}
          enableRightArrow={enableRightArrow}
          recentlySearchedLabels={recentlySearchedLabels}
          onNavigateSuggestionList={onNavigateSuggestionList}
        />
      ) : (
        <SearchSuggestions
          onClickSuggestion={onClickSuggestion}
          search={search}
          searchBarRef={searchBarRef}
          isSearchBarExpanded={isSearchBarExpanded}
          onClick={handleRemoveInputFocus}
          createSearchPath={createSearchPath}
          shouldDisableSearchBarResults={shouldDisableSearchBarResults}
          disableKeyNavigation={disableKeyNavigation}
          enableRightArrow={enableRightArrow}
          onNavigateSuggestionList={onNavigateSuggestionList}
        />
      )}
    </>
  );
};
